import "@testing-library/jest-dom";
import React from "react";
import { fireEvent, render, screen, within } from "@testing-library/react";
import PermissionsStep from "./PermissionsStep";
import type { ViewBuilderPermission } from "../../../types";

const mockUpdatePermission = jest.fn();
let mockPermissions: ViewBuilderPermission[] = [];

jest.mock("../ViewBuilderContext", () => ({
  useViewBuilderContext: () => ({
    state: { permissions: mockPermissions },
    addPermission: jest.fn(),
    updatePermission: mockUpdatePermission,
    removePermission: jest.fn(),
  }),
}));

jest.mock("../../../hooks/useGroups", () => ({
  useGroups: () => ({
    groups: [{ id: "g1", display_name: "Employees" }],
    loading: false,
    error: null,
  }),
}));

const grant = (over: Partial<ViewBuilderPermission> = {}) => ({
  id: "p1",
  groupId: "g1",
  canView: true,
  canEdit: false,
  canDelete: false,
  canExport: false,
  rowScope: "own" as const,
  ...over,
});

describe("PermissionsStep row scope", () => {
  beforeEach(() => {
    mockUpdatePermission.mockClear();
  });

  it("shows the group's row scope and lets the builder switch it to all rows", () => {
    mockPermissions = [grant()];
    render(<PermissionsStep workspaceId="ws" />);

    expect(screen.getByText("Employees")).toBeInTheDocument();
    const select = screen.getByRole("combobox", {
      name: "Rows this group sees",
    });
    expect(select).toHaveTextContent("Own");

    fireEvent.click(select);
    fireEvent.click(within(screen.getByRole("listbox")).getByText("All"));

    expect(mockUpdatePermission).toHaveBeenCalledWith("p1", {
      rowScope: "all",
    });
  });

  it("disables the row scope while the group cannot view the data", () => {
    mockPermissions = [grant({ canView: false })];
    render(<PermissionsStep workspaceId="ws" />);

    expect(
      screen.getByRole("combobox", { name: "Rows this group sees" }),
    ).toBeDisabled();
  });
});
